import PusherSystemUpdate from "@apps/pusher/components/system-update";
import { currentUserVar } from "@cache/cache";
import { graphqlNone } from "@helpers/constants";

import PusherArtifactCreated from "./components/artifact-created";
import PusherArtifactDeleted from "./components/artifact-deleted";
import PusherArtifactReordered from "./components/artifact-reordered";
import PusherArtifactUpdated from "./components/artifact-updated";
import PusherChatMessageDelta from "./components/chat-message-delta";
import PusherChatMessageFunctionCall from "./components/chat-message-function-call";
import PusherChatMessageFunctionResponseDelta from "./components/chat-message-function-response-delta";
import PusherNewChatMessage from "./components/chat-new-message";
import PusherCommentAddedOrUpdated from "./components/comment-added-or-updated";
import PusherCommentDeleted from "./components/comment-deleted";
import PusherComplianceProgramReminderSent from "./components/compliance-program-reminder-sent";
import PusherGoalProgressUpdated from "./components/goal-progress-updated";
import PusherHRISSyncComplete from "./components/hris-sync-complete";
import PusherMeetingGroupOneononeStatusChange from "./components/meeting-group-oneonone-status-change";
import PusherMeetingGroupTranscriptionBotSettingChange from "./components/meeting-group-transcription-bot-setting-change";
import PusherMeetingUpdated from "./components/meeting-updated";
import PusherRecallBotStatusChange from "./components/recall-bot-status-change";
import PusherTopicCreated from "./components/topic-created";
import PusherTopicDeleted from "./components/topic-deleted";
import PusherTopicReordered from "./components/topic-reordered";
import PusherTopicUpdated from "./components/topic-updated";
import PusherTranscriptionStatusChange from "./components/transcription-status-change";

export default function Pusher({ children }: { children: any }) {
  const currentUser = currentUserVar();
  if (currentUser.id === graphqlNone) {
    return children;
  }
  const channelName = currentUser.pusherChannelName;
  return channelName ? (
    <>
      {/* Comments */}
      <PusherCommentDeleted channelName={channelName} />
      <PusherCommentAddedOrUpdated channelName={channelName} />

      {/* Artifacts */}
      <PusherGoalProgressUpdated channelName={channelName} />
      <PusherArtifactUpdated channelName={channelName} />
      <PusherArtifactDeleted channelName={channelName} />
      <PusherArtifactCreated channelName={channelName} />
      <PusherArtifactReordered channelName={channelName} />

      {/* Ask AI */}
      <PusherChatMessageDelta channelName={channelName} />
      <PusherChatMessageFunctionResponseDelta channelName={channelName} />
      <PusherChatMessageFunctionCall channelName={channelName} />
      <PusherNewChatMessage channelName={channelName} />

      {/* Meetings */}
      <PusherTranscriptionStatusChange channelName={channelName} />
      <PusherRecallBotStatusChange channelName={channelName} />
      <PusherMeetingGroupTranscriptionBotSettingChange
        channelName={channelName}
      />
      <PusherMeetingGroupOneononeStatusChange channelName={channelName} />
      <PusherTopicReordered channelName={channelName} />
      <PusherTopicCreated channelName={channelName} />
      <PusherTopicUpdated channelName={channelName} />
      <PusherMeetingUpdated channelName={channelName} />
      <PusherTopicDeleted channelName={channelName} />

      {/* Misc */}
      <PusherHRISSyncComplete channelName={channelName} />
      <PusherComplianceProgramReminderSent channelName={channelName} />
      <PusherSystemUpdate channelName="system" />

      {children}
    </>
  ) : null;
}
